import { jsx as o } from "react/jsx-runtime";
import { forwardRef as v, useMemo as k } from "react";
import { ButtonBody as y } from "./ButtonBody.js";
import { buttonStyles as B } from "./Button.styles.js";
import { disableEventHandlers as x } from "@kds-web/common";
import { blockedEventHandlers as E } from "./Button.js";
const H = v(function({
  loading: t = !1,
  loadingAccessibleLabel: s,
  label: a,
  className: n,
  variant: i = "primary",
  size: m = "medium",
  disabled: e = !1,
  iconLeft: l,
  iconRight: d,
  href: f,
  ...u
}, c) {
  const r = e || t, p = k(
    () => x(r, E),
    [r]
  ), b = r ? { role: "link", "aria-disabled": !0, tabIndex: 0 } : { href: f, ...u };
  return /* @__PURE__ */ o(
    "a",
    {
      className: B({
        className: n,
        variant: i,
        size: m,
        disabled: e,
        loading: t
      }),
      "aria-busy": t,
      "aria-live": t ? "assertive" : void 0,
      ref: c,
      ...b,
      ...p,
      children: /* @__PURE__ */ o(
        y,
        {
          loading: t,
          loadingAccessibleLabel: s,
          label: a,
          iconLeft: l,
          iconRight: d
        }
      )
    }
  );
});
H.displayName = "ButtonLink";
export {
  H as ButtonLink,
  H as default
};
